import { Editor } from 'grapesjs';
import { EditorComponentDefinition } from '../types';
import { ReferralDataGrapesComponent } from './referral-data-grapes-component';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';
import { referralCodesIcon } from '../../../../shared/icons';

export const referralCodeComponentDefinition: EditorComponentDefinition = {
  id: 'referral-code',
  icon: referralCodesIcon,
  category: 'Loyalty',
  getLabel: ({ t }) => t('editor.component.referral'),
  component: ReferralCodeGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
};

export function ReferralCodeGrapesComponent(editor: Editor) {
  ReferralDataGrapesComponent(editor);

  const languages = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(referralCodeComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-referral-code');
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        draggable: '[data-gjs-type=column]',
        droppable: false,
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.referral-code.title',
                        { l: language },
                      )}</h1>
                      <p class="ql-align-center"><br></p>
                      <h2 class="qlfeditor-subtitle ql-align-center">${editor.I18n.t(
                        'editor.referral-code.subtitle',
                        { l: language },
                      )}</h2>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'referral-data',
          },
        ],
        attributes: {
          class: 'qlfeditor-referral-code qlf-scrollable',
          tagName: 'section',
          'aria-label': 'aria.referral.label',
          'aria-description': 'aria.referral.description',
        },

        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
